(function() {
    $(document).ready(function() {

        $('.js24BackToTop').on('click', function() {
            $('html, body').stop().animate({
                'scrollTop': 0,
            });
        });

        $(window).scroll(function() {
            updateBackToTopPosition();
            if ($(window).scrollTop() < 110) {
                $('.js24BackToTop').stop().fadeOut('fast');
            } else {
                $('.js24BackToTop').stop().fadeIn('fast');
            }
        });

        $(window).resize(function() {
            if ($(window).width() < 1750) {
                $('.js24BackToTop').stop().fadeOut('fast');
            } else {
                updateBackToTopPosition();
                $('.js24BackToTop').stop().fadeIn('fast');
            }
        });
    });

    function updateBackToTopPosition() {

        let posRight = ($(window).width() / 2) - 730 - $('.js24BackToTop').width();
        if (posRight < 20) {
            posRight = 20;
        }

        $('.js24BackToTop').css('right', posRight + 'px');

        const windowHeight = $(document).height() - $(window).height();

        if ($(window).scrollTop() > windowHeight - 80) {
            $('.js24BackToTop').css('bottom', (80 - (windowHeight - $(window).scrollTop())) + 'px');
        } else {
            $('.js24BackToTop').css('bottom', '20px');
        }
    }
})();
